import React, { useState, useEffect } from "react";
import { Container, Grid, Typography } from "@mui/material";

import moment from "moment";
import Carousel from "react-material-ui-carousel";
import { getData } from "./UtilityFunctions";
import { getEnvironmentVariable } from "../../global/environmentVariables";
import EventCardFeatured from "../layout/EventCardFeatured";
import { userDisplayName } from "../../pages/events/components/EventFunctions";

const searchLimit = 100;

export default function FeaturedEvents(props) {
  const { title, titleProps, containerSx } = props;
  const [events, setEvents] = useState(null);

  const getEvents = async () => {
    const queryStringParameters = {
      limit: searchLimit,
      startDate: `${moment()
        .subtract(1, "week")
        .format("YYYY-MM-DD")}T00:00:00Z`,
      featured: true,
      ended: false,
      "expand[]": ["gameSystem", "photoFile", "gameStore"],
    };
    if (getEnvironmentVariable("SINGLE_GAME_SYSTEM")) {
      queryStringParameters.gameSystemId =
        getEnvironmentVariable("SINGLE_GAME_SYSTEM");
    } else if (getEnvironmentVariable("SINGLE_GAME_TYPE")) {
      queryStringParameters.gameType =
        getEnvironmentVariable("SINGLE_GAME_TYPE");
    } else if (getEnvironmentVariable("SINGLE_GAME_MANUFACTURER")) {
      queryStringParameters.gameSystemManufacturer = getEnvironmentVariable(
        "SINGLE_GAME_MANUFACTURER"
      );
    }
    var apiGetData = await getData("/events", {
      queryStringParameters: queryStringParameters,
    });

    if (apiGetData?.data?.length) {
      apiGetData.data.forEach((event) => {
        if (event.pricingDict) {
          var keys = Object.keys(event.pricingDict);
          if (keys.length > 0) {
            event.pricingInfo = {
              currency: keys[0],
              amount: (event.pricingDict[keys[0]] / 100).toFixed(2),
            };
          }
        }

        if (!event?.gameStore) {
          if (event?.gameStoreId) {
            event.gameStore = {
              id: event.gameStoreId,
              name: event?.gameStoreName,
              profileImageUrl: event?.gameStoreProfileImageUrl,
            };
          } else {
            event.owner = {
              id: event.ownerId || event?.owner?.id,
              firstName: event?.ownerFirstName,
              lastName: event?.ownerLastName,
              name:
                event?.ownerFirstName && event?.ownerLastName
                  ? userDisplayName(
                      event.ownerFirstName,
                      event.ownerLastName
                    ).trim()
                  : "",
              avatarUrl: event?.ownerAvatarUrl || event?.owner?.avatarUrl,
            };
          }
        }
      });

      apiGetData.data.sort((a, b) => {
        if (a.distance === b.distance) {
          return a.random - b.random;
        } else {
          return a.distance - b.distance;
        }
      });

      return apiGetData.data.slice(0, 12);
    }

    return apiGetData.data;
  };

  useEffect(() => {
    const check = async () => {
      try {
        var apiEvents = await getEvents();
        if (apiEvents) {
          setEvents(apiEvents);
        } else {
          setEvents([]);
        }
      } catch (err) {
        setEvents([]);
      }
    };
    check();
  }, []);

  if (!events?.length) {
    return <></>;
  }
  return (
    <Container sx={{ pt: 2, pb: 2, ...containerSx }} maxWidth="lg">
      <Grid container spacing={1} sx={{ mb: 2 }}>
        <Grid item xs={12}>
          <Typography variant="h4" gutterBottom {...titleProps}>
            {title || "Featured Events"}
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Carousel interval={50000}>
            {events.map((event, index) => {
              return <EventCardFeatured event={event} key={index} />;
            })}
          </Carousel>
        </Grid>
      </Grid>
    </Container>
  );
}
